import React from "react";
import LegalLayout from "../../components/LegalLayout";

const MesafeliSatis = () => {
  return (
    <LegalLayout title="Mesafeli Satış Sözleşmesi">

      <h2>1. Taraflar</h2>

      <p>
        İşbu Mesafeli Satış Sözleşmesi, One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ.
        ("SATICI") ile www.goomorebackoffice.com internet sitesi üzerinden
        elektronik ortamda alışveriş yapan kişi ("ALICI") arasında,
        6502 Sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli
        Sözleşmeler Yönetmeliği hükümlerine uygun olarak düzenlenmiştir.
      </p>

      <br />

      <h2>2. Satıcı Bilgileri</h2>

      <ul>
        <li><strong>Şirket Ünvanı:</strong> One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ.</li>
        <li><strong>Adres:</strong> Genç Osman Mahallesi Pınar Sokak No:9 Güngören / İstanbul</li>
        <li><strong>Telefon:</strong> +90 537 210 14 52</li>
        <li><strong>E-posta:</strong> goomoreinternational@gmail.com</li>
        <li><strong>Vergi Dairesi:</strong> Esenler Vergi Dairesi</li>
        <li><strong>Vergi No:</strong> 6430860629</li>
      </ul>

      <br />

      <h2>3. Sözleşmenin Konusu</h2>

      <p>
        İşbu sözleşmenin konusu, ALICI'nın internet sitesi üzerinden elektronik
        ortamda sipariş verdiği ürün veya ürünlerin satışı ve teslimine ilişkin
        tarafların hak ve yükümlülüklerinin belirlenmesidir.
      </p>

      <br />

      <h2>4. Sipariş Bilgileri</h2>

      <p>
        Sipariş sırasında oluşturulan aşağıdaki bilgiler işbu sözleşmenin
        ayrılmaz bir parçasını oluşturur.
      </p>

      <ul>
        <li>Ürün adı</li>
        <li>Ürün adedi</li>
        <li>Birim satış fiyatı</li>
        <li>KDV dahil toplam tutar</li>
        <li>Kargo ücreti (varsa)</li>
        <li>Toplam ödeme tutarı</li>
      </ul>

      <br />

      <h2>5. Sipariş ve Ödeme</h2>

      <p>
        Sipariş, ödeme işleminin başarıyla tamamlanmasının ardından yürürlüğe
        girer.
      </p>

      <p>
        Ödeme işlemleri, lisanslı ödeme kuruluşlarının SSL korumalı güvenli
        ödeme altyapısı üzerinden gerçekleştirilmektedir.
      </p>

      <p>
        Kredi veya banka kartı bilgileriniz One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ. sistemlerinde kesinlikle saklanmaz.
      </p>

      <br />

      <h2>6. Teslimat</h2>

      <p>
        Siparişler ödeme onayının ardından hazırlanarak anlaşmalı kargo
        firmalarına teslim edilir.
      </p>

      <p>
        Normal şartlarda teslimat süresi 1-5 iş günü olup, resmi tatiller,
        yoğunluk veya mücbir sebepler nedeniyle değişiklik gösterebilir.
      </p>

      <br />

      <h2>7. Cayma Hakkı</h2>

      <p>
        ALICI, ürünü teslim aldığı tarihten itibaren 14 (ondört) gün içerisinde
        herhangi bir gerekçe göstermeksizin cayma hakkını kullanabilir.
      </p>

      <p>
        Cayma hakkının kullanılabilmesi için ürünün kullanılmamış, orijinal
        ambalajının bozulmamış ve yeniden satılabilir durumda olması
        gerekmektedir.
      </p>

      <br />

      <h2>8. İade İşlemleri</h2>

      <p>
        İade edilen ürün gerekli kontrollerden geçirildikten sonra uygun
        bulunması halinde ödeme, ALICI'nın ödeme yaptığı yöntem kullanılarak
        yasal süre içerisinde iade edilir.
      </p>

      <br />

      <h2>9. Cayma Hakkının Kullanılamadığı Durumlar</h2>

      <ul>
        <li>Hijyen nedeniyle ambalajı açılmış ürünler</li>
        <li>Kişiye özel hazırlanan ürünler</li>
        <li>Kullanılmış ürünler</li>
        <li>Mevzuat gereği iadesi mümkün olmayan ürünler</li>
      </ul>

      <br />

      <h2>10. Mücbir Sebepler</h2>

      <p>
        Doğal afet, savaş, salgın hastalık, grev, resmi makam kararları,
        ulaşım sorunları ve tarafların kontrolü dışında gelişen olaylar
        nedeniyle teslimat süreleri uzayabilir.
      </p>

      <br />

      <h2>11. Uyuşmazlıkların Çözümü</h2>

      <p>
        İşbu sözleşmeden doğabilecek uyuşmazlıklarda, Ticaret Bakanlığı
        tarafından her yıl belirlenen parasal sınırlar dahilinde Tüketici
        Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.
      </p>

      <br />

      <h2>12. Yürürlük</h2>

      <p>
        ALICI, internet sitesi üzerinden sipariş verdiğinde işbu Mesafeli
        Satış Sözleşmesi'nin tüm hükümlerini okuduğunu, anladığını ve kabul
        ettiğini beyan etmiş sayılır.
      </p>

    </LegalLayout>
  );
};

export default MesafeliSatis;